import { useState } from 'react';
import { supabase } from '../supabaseClient';
import Papa from 'papaparse';

export default function DatasetInput({ user, onUploadSuccess }) {
  const [name, setName] = useState('');
  const [uploading, setUploading] = useState(false);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Auto-fill dataset name from filename if empty
    if (!name) setName(file.name.replace('.csv', ''));

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const rows = results.data;
        if (rows.length === 0) return;

        // DYNAMICALLY DETECT COLUMNS
        // Logic: First column = DMU Name. 
        // Columns starting with 'I' or 'x' = Inputs.
        // Columns starting with 'O' or 'y' = Outputs.
        const keys = Object.keys(rows[0]);
        const nameKey = keys[0]; // Assume first column is Name
        const inputKeys = keys.filter(k => k.toLowerCase().startsWith('i') || k.toLowerCase().startsWith('x'));
        const outputKeys = keys.filter(k => k.toLowerCase().startsWith('o') || k.toLowerCase().startsWith('y'));

        const parsedData = rows.map(row => ({
          name: row[nameKey],
          inputs: inputKeys.map(k => parseFloat(row[k])),
          outputs: outputKeys.map(k => parseFloat(row[k])),
        }));

        // Upload to Supabase
        setUploading(true);
        const { error } = await supabase.from('datasets').insert({
          user_id: user.id,
          name: name || file.name,
          data: { dmus: parsedData },
        });

        setUploading(false);

        if (error) {
          alert('Error uploading: ' + error.message);
        } else {
          alert('Dataset uploaded successfully!');
          if (onUploadSuccess) onUploadSuccess(); // Trigger refresh in parent
        }
      },
    });
  };

  return (
    <div style={{ padding: '20px', background: '#e9ecef', borderRadius: '8px', marginBottom: '20px' }}>
      <h3>1. Upload New Dataset</h3>
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <input 
          type="text" 
          placeholder="Dataset Name (Optional)" 
          value={name} 
          onChange={(e) => setName(e.target.value)}
          style={{ padding: '8px' }}
        />
        <input 
          type="file" 
          accept=".csv" 
          onChange={handleFileUpload} 
          disabled={uploading}
        />
        {uploading && <span>Uploading...</span>}
      </div>
      <p style={{ fontSize: '0.8rem', color: '#666' }}>
        Format: Col 1 = Name, Cols starting with 'I' = Inputs, Cols starting with 'O' = Outputs.
      </p>
    </div>
  );
}